import {
  Companion_instance3cy7oygvo3vp5 as Companion_instance,
  Request3h9l52knfhl5u as Request,
} from './databaseModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Addresscpovxna1tjmg as Address } from './supportModels.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_name(_this__u8e3s4) {
  return _this__u8e3s4.prop(Request_name_getInstance());
}
function get_address(_this__u8e3s4) {
  return _this__u8e3s4.prop(Request_address_getInstance());
}
function prepareRequestFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [Request_name_getInstance(), Request_address_getInstance()];
  var tmp = Companion_instance.k2a();
  properties(tmp, (it) => props);
}
function Request_name$name$delegate$lambda() {
  return Companion_instance.k2a().az().v11(0);
}
function Request_name$_get_name_$ref_urij5k() {
  return (p0) => p0.i20();
}
function Request_name$serializer$delegate$lambda() {
  var tmp = Companion_instance.k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Request_name$_get_serializer_$ref_yx8vjj() {
  return (p0) => p0.h2j();
}
function Request_name$annotations$delegate$lambda() {
  return Companion_instance.k2a().az().x11(0);
}
function Request_name$_get_annotations_$ref_x9nep9() {
  return (p0) => p0.bz();
}
var Request_nameClass;
function Request_name() {
  if (Request_nameClass === VOID) {
    class $ {
      constructor() {
        Request_name_instance = this;
        var tmp = this;
        tmp.r7y_1 = lazy(Request_name$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.s7y_1 = lazy(Request_name$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.t7y_1 = lazy(Request_name$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.r7y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Request_name$_get_name_$ref_urij5k(), null);
        return tmp0.f2();
      }
      u7y(receiver) {
        return receiver.v7y_1;
      }
      k2j(receiver) {
        return this.u7y(receiver instanceof Request() ? receiver : THROW_CCE());
      }
      x7y(receiver, value) {
        return receiver.y7y(value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof Request() ? receiver : THROW_CCE();
        return this.x7y(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.s7y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Request_name$_get_serializer_$ref_yx8vjj(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.t7y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Request_name$_get_annotations_$ref_x9nep9(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'Request_name', VOID, VOID, [SerializableProperty()]);
    Request_nameClass = $;
  }
  return Request_nameClass;
}
var Request_name_instance;
function Request_name_getInstance() {
  if (Request_name_instance === VOID)
    new (Request_name())();
  return Request_name_instance;
}
function Request_address$name$delegate$lambda() {
  return Companion_instance.k2a().az().v11(1);
}
function Request_address$_get_name_$ref_cv3frj() {
  return (p0) => p0.i20();
}
function Request_address$serializer$delegate$lambda() {
  var tmp = Companion_instance.k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Request_address$_get_serializer_$ref_mlar6w() {
  return (p0) => p0.h2j();
}
function Request_address$annotations$delegate$lambda() {
  return Companion_instance.k2a().az().x11(1);
}
function Request_address$_get_annotations_$ref_q2k7c4() {
  return (p0) => p0.bz();
}
var Request_addressClass;
function Request_address() {
  if (Request_addressClass === VOID) {
    class $ {
      constructor() {
        Request_address_instance = this;
        var tmp = this;
        tmp.z7y_1 = lazy(Request_address$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.a7z_1 = lazy(Request_address$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.b7z_1 = lazy(Request_address$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.z7y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Request_address$_get_name_$ref_cv3frj(), null);
        return tmp0.f2();
      }
      u7y(receiver) {
        return receiver.w7y_1;
      }
      k2j(receiver) {
        return this.u7y(receiver instanceof Request() ? receiver : THROW_CCE());
      }
      c7z(receiver, value) {
        return receiver.y7y(VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof Request() ? receiver : THROW_CCE();
        return this.c7z(tmp, value instanceof Address() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.a7z_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Request_address$_get_serializer_$ref_mlar6w(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.b7z_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Request_address$_get_annotations_$ref_q2k7c4(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'Request_address', VOID, VOID, [SerializableProperty()]);
    Request_addressClass = $;
  }
  return Request_addressClass;
}
var Request_address_instance;
function Request_address_getInstance() {
  if (Request_address_instance === VOID)
    new (Request_address())();
  return Request_address_instance;
}
//region block: exports
export {
  get_address as get_address1quoosiozsuan,
  get_name as get_namefvrph831c91t,
  prepareRequestFields as prepareRequestFields1o0zztds0oty,
};
//endregion

//# sourceMappingURL=RequestFields.mjs.map
